import { takeLatest, call, put, all } from "redux-saga/effects";
import {
  signIn,
  send2FA,
  verify2FA,
  verify2FACode,
  signOutWithCookies,
  refreshWithCookies,
  fetchAccountList,
  fetchAccountInfo,
  signInCredential,
  fetchAccountName,
  verify2FAAuthenticator,
  signInDSA,
  signInSSO,
} from "../_services/authentication.services";
import {
  signInSuccess,
  signInSuccessForMobile,
  signInFailure,
  verify2FAOpen,
  // getAccountListStart,
  getAccountMKT,
  getAccountListSuccess,
  getAccountListFailure,
  getAccountInfoSuccess,
  getAccountInfoFailure,
  toggleErrorMessageModal,
  signOut,
  getAccountNameSuccess,
  getAccountNameFailure,
  set2FALoading,
  updateAccountListMobileSuccess,
} from "../_actions/authentication.actions";
import { updateErrorModal } from "../_actions/main.actions";

import { fetchFavoriteFundsByAccountStart } from "../_actions/favorite.actions";

import { twoFactorAuthenticationMethodConstants } from "../_constants/twoFactorAuthenticationMethod.constants";
import { authenticationConstants } from "../_constants/authentication.constants";
import { clearCookies, getCookie, setCookie } from "../_utils/cookie.utils";
import {
  updateUserAccounts,
  resetInvestment,
} from "../_actions/investment.actions";
import { resetUserCategories } from "../_actions/fund-ranking.actions";
import { nanoid } from "nanoid";
import jwt_decode from "jwt-decode";
import { errorMessageResponse } from "../_utils/service.utils";

// Worker
export function* signOutAsync() {
  // clear refreshToken & accessToken in cookies.
  const cookies = {
    refreshToken: getCookie("refreshToken"),
    accessToken: getCookie("accessToken"),
  };
  try {
    yield call(signOutWithCookies, cookies);
  } catch (err) {}
  clearCookies(["token", "accessToken", "refreshToken"]);
  yield put(resetInvestment());
  yield put(resetUserCategories());
}

export function* refreshTokenAsync() {
  const cookies = {
    refreshToken: getCookie("refreshToken"),
    token: getCookie("accessToken"),
  };
  try {
    const result = yield call(refreshWithCookies, cookies);
    const newAccessToken = result.data.token;
    if (result.data.token) {
      // Add accesstoken to cookies.
      let accessToken = getCookie("accessToken");
      if (accessToken !== newAccessToken) {
        setCookie("accessToken", newAccessToken);
      }
    }
  } catch (error) {
    if (error.response?.status === 401) {
      yield put(
        updateErrorModal({
          title: "Session Expired",
          message: "Please log in again.",
        })
      );
      yield put(signOut());
    }
  }
}

export function* signInAsync({ payload }) {
  try {
    const { username, password, history } = payload;
    let credentials = {};
    credentials.applicationId = "8961b7f1-e671-4262-b719-8c1fa1bcadd5";
    credentials.username = username;
    credentials.password = password;
    credentials.ipAddress = "127.0.0.1";
    credentials.deviceId = nanoid(36);
    credentials.deviceName = navigator.userAgent;

    const result = yield call(signIn, credentials);
    if (
      !result.data.isTwoFactorAuthenticated &&
      result.data.twoFactorAuthenticationMethod !==
        twoFactorAuthenticationMethodConstants.BYPASS
    ) {
      if (
        result.data.twoFactorAuthenticationMethod ===
          twoFactorAuthenticationMethodConstants.SMS ||
        result.data.twoFactorAuthenticationMethod ===
          twoFactorAuthenticationMethodConstants.EMAIL
      ) {
        const application = {
          applicationId: credentials.applicationId,
          accessToken: result.data.accessToken,
        };
        const send2FAResult = yield call(send2FA, application);
        const twoFactorInfo = {
          twoFactorAuthenticationMethod:
            result.data.twoFactorAuthenticationMethod,
          referenceCode: send2FAResult.data.referenceCode ?? "",
          twoFactorId: null,
          twoFactorToken: result.data.accessToken,
        };
        yield put(verify2FAOpen(twoFactorInfo));
      } else if (
        result.data.twoFactorAuthenticationMethod ===
        twoFactorAuthenticationMethodConstants.AUTHENTICATOR
      ) {
        const twoFactorInfo = {
          twoFactorAuthenticationMethod:
            result.data.twoFactorAuthenticationMethod,
          referenceCode: null,
          twoFactorId: result.data.twoFactorId,
          twoFactorToken: result.data.accessToken,
        };
        yield put(verify2FAOpen(twoFactorInfo));
      } else if (
        result.data.twoFactorAuthenticationMethod ===
        twoFactorAuthenticationMethodConstants.NONE
      ) {
        yield put(set2FALoading(false));
        yield put(
          updateErrorModal({
            title: "ช่องทางการยืนยันตัวตน",
            message:
              "กรุณาเลือกช่องทางยืนยันตัวตน ก่อนเข้าให้งาน Krungsri Securities iFund จากวิธีต่อไปนี้\n1. SMS OTP ผ่านเบอร์มือถือที่ท่านแจ้งไว้\n2. ผ่าน Google Authenticator",
          })
        );
      }
    } else {
      yield put(signInSuccess({ user: result.data, logInType: "general" }));

      // Get User Account List.
      // yield put(getAccountListStart());
      const accountListResult = yield call(fetchAccountList);
      yield put(getAccountListSuccess(accountListResult.data?.accountList));
      yield put(getAccountMKT(accountListResult.data?.mkt));
      yield put(
        updateUserAccounts(accountListResult.data?.accountList.slice(0, 1))
      );

      // Store token in cookies.
      const newAccessToken = result.data.accessToken;
      if (result.data.accessToken) {
        // Add accesstoken to cookies.
        let accessToken = getCookie("accessToken");
        if (accessToken !== newAccessToken) {
          setCookie("accessToken", newAccessToken);
        }
      }
      const newRefreshToken = result.data.refreshToken;
      if (result.data.refreshToken) {
        // Add refreshtoken to cookies.
        let refreshToken = getCookie("refreshToken");
        if (refreshToken !== newRefreshToken) {
          setCookie("refreshToken", newRefreshToken);
        }
      }

      // Get Favorite funds.
      if (Object.keys(result.data).length && accountListResult.data.length) {
        yield put(fetchFavoriteFundsByAccountStart());
        yield put(updateUserAccounts(accountListResult.data?.slice(0, 1)));
      }
      // Redirect to config page then log in success.
      // history.push('/main/investment');
    }
  } catch (error) {
    // Sign out and clear account list.
    yield put(signInFailure(errorMessageResponse(error)));
    yield put(toggleErrorMessageModal());
    // yield put(getAccountListFailure()); // to be check is this necessary to update
  }
}

export function* verify2FAAsync({ payload }) {
  try {
    const {
      verifyCode,
      referenceCode,
      twoFactorId,
      twoFactorAuthenticationMethod,
      twoFactorToken,
    } = payload;
    let result = {};
    let credentials = {};
    credentials.applicationId = "8961b7f1-e671-4262-b719-8c1fa1bcadd5";
    credentials.code = verifyCode;
    credentials.ipAddress = "127.0.0.1";
    credentials.deviceId = nanoid(36);
    credentials.deviceName = navigator.userAgent;
    credentials.accessToken = twoFactorToken;

    if (
      twoFactorAuthenticationMethod ===
        twoFactorAuthenticationMethodConstants.SMS ||
      twoFactorAuthenticationMethod ===
        twoFactorAuthenticationMethodConstants.EMAIL
    ) {
      credentials.referenceCode = referenceCode;

      if (referenceCode === "") {
        result = yield call(verify2FA, credentials);
      } else {
        result = yield call(verify2FACode, credentials);
      }
    }
    if (
      twoFactorAuthenticationMethod ===
      twoFactorAuthenticationMethodConstants.AUTHENTICATOR
    ) {
      try {
        credentials.twoFactorId = twoFactorId;
        result = yield call(verify2FAAuthenticator, credentials);
      } catch (error) {
        credentials.referenceCode = referenceCode;

        if (referenceCode === "") {
          result = yield call(verify2FA, credentials);
        } else {
          result = yield call(verify2FACode, credentials);
        }
      }
    }

    yield put(signInSuccess({ user: result.data, logInType: "general" }));

    // Get User Account List.
    // yield put(getAccountListStart());
    const accountListResult = yield call(fetchAccountList);
    yield put(getAccountListSuccess(accountListResult.data?.accountList));
    yield put(getAccountMKT(accountListResult.data?.mkt));
    yield put(
      updateUserAccounts(accountListResult.data?.accountList.slice(0, 1))
    );

    // Store token in cookies.
    const newAccessToken = result.data.accessToken;
    if (result.data.accessToken) {
      // Add accesstoken to cookies.
      let accessToken = getCookie("accessToken");
      if (accessToken !== newAccessToken) {
        setCookie("accessToken", newAccessToken);
      }
    }
    const newRefreshToken = result.data.refreshToken;
    if (result.data.refreshToken) {
      // Add refreshtoken to cookies.
      let refreshToken = getCookie("refreshToken");
      if (refreshToken !== newRefreshToken) {
        setCookie("refreshToken", newRefreshToken);
      }
    }

    // Get Favorite funds.
    if (Object.keys(result.data)?.length && accountListResult.data?.length) {
      yield put(fetchFavoriteFundsByAccountStart());
      yield put(updateUserAccounts(accountListResult.data?.slice(0, 1)));
    }
  } catch (error) {
    // Sign out and clear account list.
    yield put(signInFailure(errorMessageResponse(error)));
    yield put(toggleErrorMessageModal());
    // yield put(getAccountListFailure()); // to be check is this necessary to update
  }
}

export function* updateSignInStatusForMobileAsync() {
  try {
    const token = getCookie("accessToken");
    const decodedJwt = token ? jwt_decode(token) : null;
    const isExpiredToken = decodedJwt
      ? new Date(decodedJwt.exp * 1000).getTime() < new Date().getTime()
      : false;

    if (token && !isExpiredToken) {
      yield put(
        signInSuccessForMobile({
          user: {
            accessToken: token,
          },
          logInType: "token",
        })
      );
      // Get User Account List.
      const accountListResult = yield call(fetchAccountList);
      yield put(getAccountListSuccess(accountListResult.data?.accountList));
      yield put(getAccountMKT(accountListResult.data?.mkt));

      const accountList = accountListResult.data?.accountList ?? [];

      yield put(
        updateUserAccounts(
          accountList.length > 0 ? accountList.slice(0, 1) : []
        )
      );

      // Get Favorite funds.
      if (accountListResult.data.length) {
        yield put(fetchFavoriteFundsByAccountStart());
        yield put(updateUserAccounts(accountListResult.data?.slice(0, 1)));
      }
    }
  } catch (error) {
    clearCookies(["accessToken", "refreshToken"]);
    yield put(resetInvestment());
    yield put(signInFailure(error.message));
  }
}

export function* signInCredentialAsync({ payload }) {
  const { history } = payload;
  try {
    // add Account List from user.
    const result = yield call(signInCredential);
    yield put(signInSuccess({ user: result.data, logInType: "AD" }));

    // Get User Account List.
    // yield put(getAccountListStart());
    const accountListResult = yield call(fetchAccountList);
    yield put(getAccountListSuccess(accountListResult.data?.accountList));
    yield put(getAccountMKT(accountListResult.data?.mkt));
    yield put(
      updateUserAccounts(accountListResult.data?.accountList.slice(0, 1))
    );

    // Get Favorite funds.
    if (Object.keys(result.data).length && accountListResult.data.length) {
      yield put(fetchFavoriteFundsByAccountStart());
      yield put(updateUserAccounts(accountListResult.data?.slice(0, 1)));
    }

    // history.push('/main');
  } catch (error) {
    if (error.response.status === 401) {
      yield put(signInFailure("You are unauthorized to access"));
      yield put(toggleErrorMessageModal());
    }
    // Sign out and clear account list.
    // yield put(signInFailure(error.message));
    // yield put(getAccountListFailure());
    // yield put(signOut());
    // history.push('/main');
  }
}

export function* signInDSAAsync({ payload }) {
  const { history } = payload;
  try {
    // add Account List from user.
    const result = yield call(signInDSA, history.location.search);
    yield put(signInSuccess({ user: result.data, logInType: "DSA" }));

    // Get User Account List.
    const accountListResult = yield call(fetchAccountList);
    yield put(getAccountListSuccess(accountListResult.data?.accountList));
    yield put(getAccountMKT(accountListResult.data?.mkt));

    // Get Favorite funds.
    if (Object.keys(result.data).length && accountListResult.data.length) {
      yield put(fetchFavoriteFundsByAccountStart());
      yield put(updateUserAccounts(accountListResult.data?.slice(0, 1)));
    }

    history.push("/main");
  } catch (error) {
    yield put(signOut());
  }
}

export function* signInSSOAsync({ payload }) {
  const { history } = payload;
  try {
    // add Account List from user.
    const result = yield call(signInSSO, history.location.search);
    yield put(signInSuccess({ user: result.data, logInType: "SSO" }));

    // Get User Account List.
    const accountListResult = yield call(fetchAccountList);
    yield put(getAccountListSuccess(accountListResult.data?.accountList));
    yield put(getAccountMKT(accountListResult.data?.mkt));
    yield put(
      updateUserAccounts(accountListResult.data?.accountList.slice(0, 1))
    );

    // Get Favorite funds.
    if (Object.keys(result.data).length && accountListResult.data.length) {
      yield put(fetchFavoriteFundsByAccountStart());
      yield put(updateUserAccounts(accountListResult.data?.slice(0, 1)));
    }

    history.push("/main");
  } catch (error) {
    yield put(signOut());
  }
}

export function* getAccountListAsync({ payload }) {
  try {
    // add Account List from user.
    const result = yield call(fetchAccountList);
    yield put(getAccountListSuccess(result.data?.accountList));
    yield put(getAccountMKT(result.data?.mkt));
    yield put(updateAccountListMobileSuccess());
  } catch (error) {
    yield put(getAccountListFailure());
  }
}

export function* getAccountInfoAsync({ payload }) {
  try {
    const result = yield call(fetchAccountInfo, payload);
    yield put(getAccountInfoSuccess(result.data));
  } catch (error) {
    yield put(getAccountInfoFailure());
  }
}

export function* getAccountNameAsync({ payload }) {
  try {
    const result = yield call(fetchAccountName, payload);
    yield put(getAccountNameSuccess(result.data));
  } catch (error) {
    yield put(getAccountNameFailure());
  }
}

// Watcher
export function* signOutStart() {
  yield takeLatest(authenticationConstants.SIGN_OUT, signOutAsync);
}

export function* refreshTokenStart() {
  yield takeLatest(authenticationConstants.REFRESH_TOKEN, refreshTokenAsync);
}

export function* signInStart() {
  yield takeLatest(authenticationConstants.SIGN_IN_START, signInAsync);
}

export function* updateSignInStatusForMobile() {
  yield takeLatest(
    authenticationConstants.UPDATE_SIGN_IN_STATUS_FOR_MOBILE,
    updateSignInStatusForMobileAsync
  );
}

export function* signInCredentialStart() {
  yield takeLatest(
    authenticationConstants.SIGN_IN_CREDENTIAL_START,
    signInCredentialAsync
  );
}

export function* signInDSAStart() {
  yield takeLatest(authenticationConstants.SIGN_IN_DSA_START, signInDSAAsync);
}

export function* signInSSOStart() {
  yield takeLatest(authenticationConstants.SIGN_IN_SSO_START, signInSSOAsync);
}

export function* getAccountListSaga() {
  yield takeLatest(
    authenticationConstants.GET_ACCOUNT_LIST_START,
    getAccountListAsync
  );
}

export function* getAccountInfoSaga() {
  yield takeLatest(
    authenticationConstants.GET_ACCOUNT_INFO_START,
    getAccountInfoAsync
  );
}

export function* getAccountNameSaga() {
  yield takeLatest(
    authenticationConstants.GET_ACCOUNT_NAME_START,
    getAccountNameAsync
  );
}

export function* verify2FAStart() {
  yield takeLatest(authenticationConstants.VERIFY_2FA_START, verify2FAAsync);
}

export function* authenticationSagas() {
  yield all([
    call(signOutStart),
    call(signInStart),
    call(signInCredentialStart),
    call(signInDSAStart),
    call(signInSSOStart),
    call(updateSignInStatusForMobile),
    call(getAccountListSaga),
    call(getAccountInfoSaga),
    call(getAccountNameSaga),
    call(refreshTokenStart),
    call(verify2FAStart),
  ]);
}
